var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{class:_vm.rowBorderClass},[_c('b-col',{attrs:{"cols":"auto"}},[_c('p',{class:`text-primary mb-0 ${_vm.freelancerLabelClass}`},[_vm._v(_vm._s(_vm.label))]),_c('p',{class:`text-secondary mb-0 ${_vm.freelancerLabelClass}`},[_vm._v(_vm._s(_vm.content))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }